/**
 * Trainova AI — RoleSelector Component
 */

interface RoleSelectorProps {
  currentRole: string;
  onChange: (role: string) => void;
  disabled?: boolean;
}

const AVAILABLE_ROLES = [
  { value: 'LEARNER', label: 'Learner' },
  { value: 'TRAINER', label: 'Trainer / Instructor' },
  { value: 'MANAGER', label: 'Manager' },
  { value: 'EVALUATOR', label: 'Evaluator' },
  { value: 'TENANT_ADMIN', label: 'Organization Admin' },
  { value: 'VIEWER', label: 'Viewer' },
];

export function RoleSelector({ currentRole, onChange, disabled }: RoleSelectorProps) {
  const normCurrent = currentRole.toUpperCase();

  return (
    <select
      value={normCurrent}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className="admin-role-select"
    >
      {AVAILABLE_ROLES.map((r) => (
        <option key={r.value} value={r.value}>
          {r.label}
        </option>
      ))}
    </select>
  );
}
